import { call, select } from 'redux-saga/effects';
import { selectSignalingInitData } from 'features/application/applicationSlice';
import { SignalingInitData } from 'features/application/types';
import { generateConnectionParams } from 'features/sdk/utils/generateConnectionParams';
import { eventBus } from 'utils/eventBus';

export function* mobileStartScreenshareRequestedSaga() {
  const initData: SignalingInitData = yield select(selectSignalingInitData);

  const payload = generateConnectionParams(initData);

  yield call(eventBus.sendMessage, 'mobileStartScreenshareRequested', {}, payload);
}
